<template>
  <div>
    <div class="checkbox-container">
      <div class="checkbox-group">
        <input
          v-model="checkedProdutor"
          type="checkbox"
          :value="component.name"
          class="cb"
          @click.stop="toggleCheckbox('produtor')"
        />
        <label class="text-value">Produtor</label>
      </div>

      <div class="checkbox-group">
        <input
          v-model="checkedResponsavel"
          type="checkbox"
          :value="component.name"
          class="cb"
          @click.stop="toggleCheckbox('responsavel')"
        />
        <label class="text-value">Responsável</label>
      </div>
    </div>
    <div class="content-group">
      <template v-if="!checkedResponsavel"
        ><RenderPreview
          v-for="field in stepFieldPreview"
          :key="field.name"
          :component="field"
        ></RenderPreview
      ></template>
    </div>
    <template v-if="checkedResponsavel"
      ><RenderPreview
        v-for="field in component?.fields1"
        :key="field.name"
        :component="field"
      ></RenderPreview
    ></template>
    <template>
      <div class="content-save">
        <label class="input-title">SALVAR RELATÓRIO</label>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  name: 'GroupRadioButton',

  components: {
    RenderPreview: () => import('./RenderPreview.vue'),
  },

  props: {
    component: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    checkedProdutor: true,
    checkedResponsavel: false,
  }),

  computed: {
    stepFieldPreview() {
      const nomesParaRemover = this.component?.fields1
        ? this.component?.fields1.map(campo => campo.name)
        : ''

      return this.component.fields.filter(campo => {
        return !nomesParaRemover.includes(campo.name)
      })
    },
  },

  methods: {
    toggleCheckbox(type) {
      if (type === 'produtor') {
        if (!this.checkedProdutor) {
          this.checkedProdutor = true
          this.checkedResponsavel = false
        }
      } else if (type === 'responsavel') {
        if (!this.checkedResponsavel) {
          this.checkedResponsavel = true
          this.checkedProdutor = false
        }
      }
    },
  },
}
</script>
<style scoped>
.checkbox-container {
  display: flex;
  padding: 10px 5px;
  margin: 0 10px;
  gap: 20px;
  background-color: #f8f8f8;
}

.checkbox-group {
  display: flex;
  align-items: center;
}

.content-group {
  display: flex;
  flex-direction: column;
  padding: 10px;
}

.text-value {
  font-size: 14px;
  font-family: 'Rajdhani', sans-serif;
  color: #69739e;
  padding-left: 10px;
}

.content-save {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 15px;
  margin: 10px;
  border-radius: 8px;
  background-color: #0ba31f;
  cursor: pointer;
}

.input-title {
  font-weight: bold;
  font-size: 14;
  font-family: 'Rajdhani', sans-serif;
  color: #fff;
  padding-left: 5px;
  cursor: pointer;
}

.cb {
  -webkit-appearance: none;
  appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 4px;
  cursor: pointer;
  background-color: white;
  border: 2px solid #10dd2c;
  position: relative;
  display: inline-block;
}

.cb::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 10px;
  height: 10px;
  transform: translate(-50%, -50%) scale(0);
  transition: transform 0.2s ease-in-out;
  clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
  background-color: #10dd2c;
}

.cb:checked {
  background-color: white;
  border-color: #10dd2c;
}

.cb:checked::before {
  transform: translate(-50%, -50%) scale(1);
}
</style>
